module.exports = __webpack_public_path__ + "static/media/Gambit.a0b1cfba.png";